import React, { useEffect, useState } from 'react';
import config from 'config';
import './Banner.css';

const BANNER_SESSION_KEY = 'mfaBannerDismissed';

const Banner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const shouldDisplayBanner = config.mfaBanner.display === 'true';

  useEffect(() => {
    if (!shouldDisplayBanner) return;

    const bannerDismissed = sessionStorage.getItem(BANNER_SESSION_KEY);

    if (!bannerDismissed) {
      setShowBanner(true);
    }
  }, [shouldDisplayBanner]);

  const handleClose = () => {
    sessionStorage.setItem(BANNER_SESSION_KEY, 'true');
    setShowBanner(false);
  };

  if (!shouldDisplayBanner || !showBanner) return null;

  return (
    <div
      className="mfa-banner"
      role="region"
      aria-label="Important security update"
    >
      <button
        data-testid="button"
        type="button"
        className="mfa-banner-close"
        onClick={handleClose}
        aria-label="Close security update banner"
      >
        ×
      </button>

      <p className="mfa-banner-text">
        We&rsquo;re enhancing your security and experience. Multi-Factor
        Authentication(MFA) will be required starting 5/21 at 8 PM, along with a
        refreshed look and feel. Learn more about MFA and why it&rsquo;s
        important{' '}
        <a
          href="https://www.cisa.gov/sites/default/files/publications/MFA-Fact-Sheet-Jan22-508.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
        .
      </p>
    </div>
  );
};

export default Banner;
